
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { filter, length, singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { PageHeader, SectionHeader } from "../../Components/Text.js";
import { useTranslation } from "react-i18next";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { Msg } from "./Types.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { Button } from "../../Components/Button.js";
import Check from "../../../public/assets/icons/Check.svg";
import { CountingView } from "../StocktakingList/CountingView.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { Skeleton } from "../../Components/Skeleton.js";
import Delete_Circle from "../../../public/assets/icons/Delete_Circle.svg";

function page(testId, children) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["data-test-id", testId], ["className", join(" ", ["min-h-full", "flex", "justify-center", "bg-background", "px-4", "py-6", "md:px-8", "md:py-10"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["w-full", "max-w-6xl", "flex", "flex-col", "gap-6"]),
        children: reactApi.Children.toArray(Array.from(children)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function messageCard(testId, icon, iconClass, title, description) {
    let elems_2, elems_1;
    return page(testId, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-lg", "mx-auto", "w-full", "p-6", "flex", "flex-col", "border", "border-border", "rounded-md", "bg-[#FFFFFF]"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["mx-auto", "w-24", "h-24", "mb-4", iconClass]),
        children: reactApi.Children.toArray([icon]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mt-4", "text-center"])], (elems_1 = [createElement(SectionHeader, {
        Text: title,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
        "data-test-id": concat(testId, ..."-description"),
        className: join(" ", ["mt-4", "text-center", "text-text-muted"]),
        children: description,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))));
}

function CountingPage(props) {
    let Title, elems_3;
    const t = useTranslation()[0];
    const stocktakingList = props.Data.StocktakingList;
    let openPositions;
    let y_1;
    const y = length(filter((tool) => (tool.Result == null), stocktakingList.Tools)) | 0;
    y_1 = (length(filter((tool_1) => (tool_1.Result == null), stocktakingList.ToolsWithQuantity)) + y);
    openPositions = (length(filter((consumable) => (consumable.Result == null), stocktakingList.Consumables)) + y_1);
    const componentState = props.State.FormState.IsLoading ? "disabled" : "enabled";
    const infoLine = (label, value, testId) => {
        let elems;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [reactElement("div", {
            className: join(" ", ["text-xs", "text-text-muted"]),
            children: label,
        }), reactElement("div", {
            "data-test-id": testId,
            className: join(" ", ["font-semibold"]),
            children: value,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return page("stocktaking-count-page", ofArray([createElement(ConfirmationDialog, (Title = t("stocktaking.email_link.guest.complete_title"), {
        Description: t("stocktaking.email_link.guest.complete_description"),
        FormState: props.State.FormState,
        IsOpen: props.State.IsCompleteDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(4, [false]));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(5, []));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "bg-white", "rounded", "px-4", "py-6", "md:px-12", "md:py-9"])], (elems_3 = toList(delay(() => append(singleton_1(createElement(PageHeader, {
        Text: props.Data.StocktakingName,
    })), delay(() => append(singleton_1(reactElement("div", {
        "data-test-id": "stocktaking-count-intro",
        className: join(" ", ["text-text-muted"]),
        children: t("stocktaking.email_link.guest.intro"),
    })), delay(() => {
        let elems_1;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-8"])], (elems_1 = [infoLine(t("stocktaking.email_link.guest.receiver"), props.Data.ReceiverName, "stocktaking-count-receiver"), infoLine(t("stocktaking.email_link.guest.list"), stocktakingList.DisplayName, "stocktaking-count-list"), infoLine(t("stocktaking.email_link.guest.end_date"), toString(toLocalTime(props.Data.EndDate), "dd.MM.yyyy"), "stocktaking-count-end-date")], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(props.State.FormState, t, "global"), (matchValue == null) ? singleton_1(defaultOf()) : singleton_1(createElement(ErrorAlert, {
                Label: matchValue,
            }))), delay(() => {
                let elems_2, Label;
                return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(Button, (Label = t("stocktaking.email_link.guest.complete"), {
                    ComponentState: (openPositions > 0) ? "disabled" : componentState,
                    Icon: Check(),
                    Label: Label,
                    OnClick: () => {
                        props.Dispatch(new Msg(4, [true]));
                    },
                    TestId: "stocktaking-count-complete-button",
                    Variant: "primary",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => ((openPositions > 0) ? singleton_1(reactElement("div", {
                    "data-test-id": "stocktaking-count-open-hint",
                    className: join(" ", ["text-sm", "text-text-muted", "text-right"]),
                    children: t("stocktaking.email_link.guest.open_positions_hint"),
                })) : empty())));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement(CountingView, {
        Counting: props.State.Counting,
        Dispatch: (arg) => {
            props.Dispatch(new Msg(3, [arg]));
        },
        StocktakingList: stocktakingList,
    })]));
}

export function StocktakingCountView(props) {
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.LinkId, undefined);
    const state_1 = patternInput_1[0];
    const matchValue_1 = state_1.Problem;
    const matchValue_2 = state_1.Data;
    if (state_1.IsCompleted) {
        return messageCard("stocktaking-count-completed", Check_Circle(), "text-icon-green", t("stocktaking.email_link.guest.completed_title"), t("stocktaking.email_link.guest.completed_description"));
    }
    else if (matchValue_1 == null) {
        if (matchValue_2.tag === 0) {
            return createElement(Skeleton, {
                Variant: "detail",
            });
        }
        else {
            return createElement(CountingPage, {
                Data: matchValue_2.fields[0],
                Dispatch: patternInput_1[1],
                State: state_1,
            });
        }
    }
    else if (matchValue_1.tag === 0) {
        return messageCard("stocktaking-count-invalid", Delete_Circle(), "text-icon-red", t("stocktaking.email_link.guest.invalid_title"), t("stocktaking.email_link.guest.invalid_description"));
    }
    else {
        const messageKey = matchValue_1.fields[0];
        return messageCard("stocktaking-count-rejected", Delete_Circle(), "text-icon-red", t("stocktaking.email_link.guest.not_possible_title"), t(messageKey));
    }
}

